<template>
    <div class="dashboard-widget-content">
        <template v-if="!value.ShowOptions">
            <chart-card-dashboard-wings no-footer :data="series[0].data">
                <pie-chart :series="series"></pie-chart>
            </chart-card-dashboard-wings>
        </template>
        <template v-else>
            <widget-options>
                <md-field>
                    <label>{{ $t('widget.options.update') }}</label>
                    <md-select v-model="options.update">
                        <md-option value="10 мин">10 мин</md-option>
                        <md-option value="Нет">Нет</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.interval') }}</label>
                    <md-select v-model="options.interval">
                        <md-option value="hour">предыдущий час</md-option>
                        <md-option value="today">сегодня</md-option>
                        <md-option value="yesterday">вчера</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.chanel') }}</label>
                    <md-select v-model="options.chanel">
                        <md-option value="SMS">{{$t('widget.channel.SMS')}}</md-option>
                        <md-option value="Call">{{$t('widget.channel.Call')}}</md-option>
                        <md-option value="Email">{{$t('widget.channel.Email')}}</md-option>
                        <md-option value="Push">{{$t('widget.channel.Push')}}</md-option>
                        <md-option value="Viber">{{$t('widget.channel.Viber')}}</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.group_by') }}</label>
                    <md-select v-model="options.group_by">
                        <md-option value="service_provider">по поставщикам услуг</md-option>
                        <md-option value="partner">по клиентам</md-option>
                    </md-select>
                </md-field>
            </widget-options>

        </template>
    </div>
</template>

<script>
  import widgetMixin from './mixin'
  import { DateTime } from 'luxon'
  export default {
    name: "ErrorsProviders",
    mixins:[widgetMixin],
    props:{
      value:{},
      fullSize:{default:false}
    },
    data(){return{
      options:{
        update:'10 мин',
        interval:'hour',
        chanel:'SMS',
        group_by:'partner',
      },
      ChartData: [
        {
          "name": "Beeline",
          "value": 30,
        }, {
          "name": "MTS",
          "value": 25,
        }, {
          "name": "Megafon",
          "value": 22,
        }, {
          "name": "Tele2",
          "value": 20,
        }, {
          "name": "Остальные",
          "value": 3,
        },
      ],
    }},
    computed:{
      series(){
        return [
          {
            name: '',
            type: 'pie',
            radius: [0, '55%'],
            label: {
              show: false,
            },
            data: [
              {value: 28, name: 'Beeline',itemStyle:{color:this.hslToHex(198,74,58)}},
              {value: 25, name: 'MTS', itemStyle:{color:this.hslToHex(122,39,49)}},
              {value: 26, name: 'Megafon', itemStyle:{color:this.hslToHex(0,0,50)}},
              {value: 21, name: 'Тele2', itemStyle:{color:this.hslToHex(34,83,50)}},
            ]
          },
          {
            name: '',
            type: 'pie',
            radius: ['65%', '90%'],
            label: {
              show: false,
            },
            data: [
              {value: 3, name: 'invalid length', itemStyle:{color:this.hslToHex(198,74,80)}},
              {value: 4, name: 'invalid address', itemStyle:{color:this.hslToHex(198,74,70)}},
              {value: 22, name: 'SMS Errors', itemStyle:{color:this.hslToHex(198,74,60)}},

              {value: 1, name: 'Остальные', itemStyle:{color:this.hslToHex(122,39,80)}},
              {value: 3, name: 'invalid address', itemStyle:{color:this.hslToHex(122,39,70)}},
              {value: 20, name: 'SMS Errors', itemStyle:{color:this.hslToHex(122,39,60)}},

              {value: 1, name: 'Остальные', itemStyle:{color:this.hslToHex(0,0,80)}},
              {value: 3, name: 'invalid address', itemStyle:{color:this.hslToHex(0,0,70)}},
              {value: 22, name: 'SMS Errors', itemStyle:{color:this.hslToHex(0,0,60)}},

              {value: 1, name: 'Остальные', itemStyle:{color:this.hslToHex(34,83,80)}},
              {value: 3, name: 'invalid address', itemStyle:{color:this.hslToHex(34,83,70)}},
              {value: 17, name: 'SMS Errors', itemStyle:{color:this.hslToHex(34,83,60)}},
            ]
          }
        ]
      }
    },
    methods:{
      title(){
        const $t = this.$t.bind(this);
        let title = $t(`widget.ErrorsProviders.title`,{chanel:$t('widget.channel.'+this.options.chanel)})+' ';

        let current = DateTime.local();
        switch (this.options.interval) {
          case 'hour':
            let start = DateTime.local().plus({hour:-1});
            title+=  ' с '+start.toFormat('HH:ss');
            title+=  ' до '+current.toFormat('HH:ss');
            break;
          case 'today':
            title+=  ' сегодня';
            break;
          case 'yesterday':
            title+=  ' вчера';
            break;
        }
        return title;
      },
      hslToHex(h, s, l) {
        h /= 360;
        s /= 100;
        l /= 100;
        let r, g, b;
        if (s === 0) {
          r = g = b = l; // achromatic
        } else {
          const hue2rgb = (p, q, t) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
          };
          const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
          const p = 2 * l - q;
          r = hue2rgb(p, q, h + 1 / 3);
          g = hue2rgb(p, q, h);
          b = hue2rgb(p, q, h - 1 / 3);
        }
        const toHex = x => {
          const hex = Math.round(x * 255).toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        };
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
      }
    }
  }
</script>
